{
  "about": "Hebcal Yom Tov days (yomtov: true), Diaspora. Written by scripts/update-hebcal-snapshot.ts.",
  "from": "2025-01-01",
  "to": "2032-12-31",
  "fetched": "2026-10-20",
  "days": [
    {
      "day": "2025-04-13",
      "title": "Pesach I",
      "hebrew": "פסח א׳"
    },
    {
      "day": "2025-04-14",
      "title": "Pesach II",
      "hebrew": "פסח ב׳"
    },
    {
      "day": "2025-04-19",
      "title": "Pesach VII",
      "hebrew": "פסח ז׳"
    },
    {
      "day": "2025-04-20",
      "title": "Pesach VIII",
      "hebrew": "פסח ח׳"
    },
    {
      "day": "2025-06-02",
      "title": "Shavuot I",
      "hebrew": "שבועות א׳"
    },
    {
      "day": "2025-06-03",
      "title": "Shavuot II",
      "hebrew": "שבועות ב׳"
    },
    {
      "day": "2025-09-23",
      "title": "Rosh Hashana 5786",
      "hebrew": "ראש השנה 5786"
    },
    {
      "day": "2025-09-24",
      "title": "Rosh Hashana II",
      "hebrew": "ראש השנה ב׳"
    },
    {
      "day": "2025-10-02",
      "title": "Yom Kippur",
      "hebrew": "יום כיפור"
    },
    {
      "day": "2025-10-07",
      "title": "Sukkot I",
      "hebrew": "סוכות א׳"
    },
    {
      "day": "2025-10-08",
      "title": "Sukkot II",
      "hebrew": "סוכות ב׳"
    },
    {
      "day": "2025-10-14",
      "title": "Shmini Atzeret",
      "hebrew": "שמיני עצרת"
    },
    {
      "day": "2025-10-15",
      "title": "Simchat Torah",
      "hebrew": "שמחת תורה"
    },
    {
      "day": "2026-04-02",
      "title": "Pesach I",
      "hebrew": "פסח א׳"
    },
    {
      "day": "2026-04-03",
      "title": "Pesach II",
      "hebrew": "פסח ב׳"
    },
    {
      "day": "2026-04-08",
      "title": "Pesach VII",
      "hebrew": "פסח ז׳"
    },
    {
      "day": "2026-04-09",
      "title": "Pesach VIII",
      "hebrew": "פסח ח׳"
    },
    {
      "day": "2026-05-22",
      "title": "Shavuot I",
      "hebrew": "שבועות א׳"
    },
    {
      "day": "2026-05-23",
      "title": "Shavuot II",
      "hebrew": "שבועות ב׳"
    },
    {
      "day": "2026-09-12",
      "title": "Rosh Hashana 5787",
      "hebrew": "ראש השנה 5787"
    },
    {
      "day": "2026-09-13",
      "title": "Rosh Hashana II",
      "hebrew": "ראש השנה ב׳"
    },
    {
      "day": "2026-09-21",
      "title": "Yom Kippur",
      "hebrew": "יום כיפור"
    },
    {
      "day": "2026-09-26",
      "title": "Sukkot I",
      "hebrew": "סוכות א׳"
    },
    {
      "day": "2026-09-27",
      "title": "Sukkot II",
      "hebrew": "סוכות ב׳"
    },
    {
      "day": "2026-10-03",
      "title": "Shmini Atzeret",
      "hebrew": "שמיני עצרת"
    },
    {
      "day": "2026-10-04",
      "title": "Simchat Torah",
      "hebrew": "שמחת תורה"
    },
    {
      "day": "2027-04-22",
      "title": "Pesach I",
      "hebrew": "פסח א׳"
    },
    {
      "day": "2027-04-23",
      "title": "Pesach II",
      "hebrew": "פסח ב׳"
    },
    {
      "day": "2027-04-28",
      "title": "Pesach VII",
      "hebrew": "פסח ז׳"
    },
    {
      "day": "2027-04-29",
      "title": "Pesach VIII",
      "hebrew": "פסח ח׳"
    },
    {
      "day": "2027-06-11",
      "title": "Shavuot I",
      "hebrew": "שבועות א׳"
    },
    {
      "day": "2027-06-12",
      "title": "Shavuot II",
      "hebrew": "שבועות ב׳"
    },
    {
      "day": "2027-10-02",
      "title": "Rosh Hashana 5788",
      "hebrew": "ראש השנה 5788"
    },
    {
      "day": "2027-10-03",
      "title": "Rosh Hashana II",
      "hebrew": "ראש השנה ב׳"
    },
    {
      "day": "2027-10-11",
      "title": "Yom Kippur",
      "hebrew": "יום כיפור"
    },
    {
      "day": "2027-10-16",
      "title": "Sukkot I",
      "hebrew": "סוכות א׳"
    },
    {
      "day": "2027-10-17",
      "title": "Sukkot II",
      "hebrew": "סוכות ב׳"
    },
    {
      "day": "2027-10-23",
      "title": "Shmini Atzeret",
      "hebrew": "שמיני עצרת"
    },
    {
      "day": "2027-10-24",
      "title": "Simchat Torah",
      "hebrew": "שמחת תורה"
    },
    {
      "day": "2028-04-11",
      "title": "Pesach I",
      "hebrew": "פסח א׳"
    },
    {
      "day": "2028-04-12",
      "title": "Pesach II",
      "hebrew": "פסח ב׳"
    },
    {
      "day": "2028-04-17",
      "title": "Pesach VII",
      "hebrew": "פסח ז׳"
    },
    {
      "day": "2028-04-18",
      "title": "Pesach VIII",
      "hebrew": "פסח ח׳"
    },
    {
      "day": "2028-05-31",
      "title": "Shavuot I",
      "hebrew": "שבועות א׳"
    },
    {
      "day": "2028-06-01",
      "title": "Shavuot II",
      "hebrew": "שבועות ב׳"
    },
    {
      "day": "2028-09-21",
      "title": "Rosh Hashana 5789",
      "hebrew": "ראש השנה 5789"
    },
    {
      "day": "2028-09-22",
      "title": "Rosh Hashana II",
      "hebrew": "ראש השנה ב׳"
    },
    {
      "day": "2028-09-30",
      "title": "Yom Kippur",
      "hebrew": "יום כיפור"
    },
    {
      "day": "2028-10-05",
      "title": "Sukkot I",
      "hebrew": "סוכות א׳"
    },
    {
      "day": "2028-10-06",
      "title": "Sukkot II",
      "hebrew": "סוכות ב׳"
    },
    {
      "day": "2028-10-12",
      "title": "Shmini Atzeret",
      "hebrew": "שמיני עצרת"
    },
    {
      "day": "2028-10-13",
      "title": "Simchat Torah",
      "hebrew": "שמחת תורה"
    },
    {
      "day": "2029-03-31",
      "title": "Pesach I",
      "hebrew": "פסח א׳"
    },
    {
      "day": "2029-04-01",
      "title": "Pesach II",
      "hebrew": "פסח ב׳"
    },
    {
      "day": "2029-04-06",
      "title": "Pesach VII",
      "hebrew": "פסח ז׳"
    },
    {
      "day": "2029-04-07",
      "title": "Pesach VIII",
      "hebrew": "פסח ח׳"
    },
    {
      "day": "2029-05-20",
      "title": "Shavuot I",
      "hebrew": "שבועות א׳"
    },
    {
      "day": "2029-05-21",
      "title": "Shavuot II",
      "hebrew": "שבועות ב׳"
    },
    {
      "day": "2029-09-10",
      "title": "Rosh Hashana 5790",
      "hebrew": "ראש השנה 5790"
    },
    {
      "day": "2029-09-11",
      "title": "Rosh Hashana II",
      "hebrew": "ראש השנה ב׳"
    },
    {
      "day": "2029-09-19",
      "title": "Yom Kippur",
      "hebrew": "יום כיפור"
    },
    {
      "day": "2029-09-24",
      "title": "Sukkot I",
      "hebrew": "סוכות א׳"
    },
    {
      "day": "2029-09-25",
      "title": "Sukkot II",
      "hebrew": "סוכות ב׳"
    },
    {
      "day": "2029-10-01",
      "title": "Shmini Atzeret",
      "hebrew": "שמיני עצרת"
    },
    {
      "day": "2029-10-02",
      "title": "Simchat Torah",
      "hebrew": "שמחת תורה"
    },
    {
      "day": "2030-04-18",
      "title": "Pesach I",
      "hebrew": "פסח א׳"
    },
    {
      "day": "2030-04-19",
      "title": "Pesach II",
      "hebrew": "פסח ב׳"
    },
    {
      "day": "2030-04-24",
      "title": "Pesach VII",
      "hebrew": "פסח ז׳"
    },
    {
      "day": "2030-04-25",
      "title": "Pesach VIII",
      "hebrew": "פסח ח׳"
    },
    {
      "day": "2030-06-07",
      "title": "Shavuot I",
      "hebrew": "שבועות א׳"
    },
    {
      "day": "2030-06-08",
      "title": "Shavuot II",
      "hebrew": "שבועות ב׳"
    },
    {
      "day": "2030-09-28",
      "title": "Rosh Hashana 5791",
      "hebrew": "ראש השנה 5791"
    },
    {
      "day": "2030-09-29",
      "title": "Rosh Hashana II",
      "hebrew": "ראש השנה ב׳"
    },
    {
      "day": "2030-10-07",
      "title": "Yom Kippur",
      "hebrew": "יום כיפור"
    },
    {
      "day": "2030-10-12",
      "title": "Sukkot I",
      "hebrew": "סוכות א׳"
    },
    {
      "day": "2030-10-13",
      "title": "Sukkot II",
      "hebrew": "סוכות ב׳"
    },
    {
      "day": "2030-10-19",
      "title": "Shmini Atzeret",
      "hebrew": "שמיני עצרת"
    },
    {
      "day": "2030-10-20",
      "title": "Simchat Torah",
      "hebrew": "שמחת תורה"
    },
    {
      "day": "2031-04-08",
      "title": "Pesach I",
      "hebrew": "פסח א׳"
    },
    {
      "day": "2031-04-09",
      "title": "Pesach II",
      "hebrew": "פסח ב׳"
    },
    {
      "day": "2031-04-14",
      "title": "Pesach VII",
      "hebrew": "פסח ז׳"
    },
    {
      "day": "2031-04-15",
      "title": "Pesach VIII",
      "hebrew": "פסח ח׳"
    },
    {
      "day": "2031-05-28",
      "title": "Shavuot I",
      "hebrew": "שבועות א׳"
    },
    {
      "day": "2031-05-29",
      "title": "Shavuot II",
      "hebrew": "שבועות ב׳"
    },
    {
      "day": "2031-09-18",
      "title": "Rosh Hashana 5792",
      "hebrew": "ראש השנה 5792"
    },
    {
      "day": "2031-09-19",
      "title": "Rosh Hashana II",
      "hebrew": "ראש השנה ב׳"
    },
    {
      "day": "2031-09-27",
      "title": "Yom Kippur",
      "hebrew": "יום כיפור"
    },
    {
      "day": "2031-10-02",
      "title": "Sukkot I",
      "hebrew": "סוכות א׳"
    },
    {
      "day": "2031-10-03",
      "title": "Sukkot II",
      "hebrew": "סוכות ב׳"
    },
    {
      "day": "2031-10-09",
      "title": "Shmini Atzeret",
      "hebrew": "שמיני עצרת"
    },
    {
      "day": "2031-10-10",
      "title": "Simchat Torah",
      "hebrew": "שמחת תורה"
    },
    {
      "day": "2032-03-27",
      "title": "Pesach I",
      "hebrew": "פסח א׳"
    },
    {
      "day": "2032-03-28",
      "title": "Pesach II",
      "hebrew": "פסח ב׳"
    },
    {
      "day": "2032-04-02",
      "title": "Pesach VII",
      "hebrew": "פסח ז׳"
    },
    {
      "day": "2032-04-03",
      "title": "Pesach VIII",
      "hebrew": "פסח ח׳"
    },
    {
      "day": "2032-05-16",
      "title": "Shavuot I",
      "hebrew": "שבועות א׳"
    },
    {
      "day": "2032-05-17",
      "title": "Shavuot II",
      "hebrew": "שבועות ב׳"
    },
    {
      "day": "2032-09-06",
      "title": "Rosh Hashana 5793",
      "hebrew": "ראש השנה 5793"
    },
    {
      "day": "2032-09-07",
      "title": "Rosh Hashana II",
      "hebrew": "ראש השנה ב׳"
    },
    {
      "day": "2032-09-15",
      "title": "Yom Kippur",
      "hebrew": "יום כיפור"
    },
    {
      "day": "2032-09-20",
      "title": "Sukkot I",
      "hebrew": "סוכות א׳"
    },
    {
      "day": "2032-09-21",
      "title": "Sukkot II",
      "hebrew": "סוכות ב׳"
    },
    {
      "day": "2032-09-27",
      "title": "Shmini Atzeret",
      "hebrew": "שמיני עצרת"
    },
    {
      "day": "2032-09-28",
      "title": "Simchat Torah",
      "hebrew": "שמחת תורה"
    }
  ]
}
